import { AxiosPromise } from 'axios';
import { IGetLocale, IGetLocales, ILocaleReq } from '../models/i18n.model';
import axios from 'axios';

const uri = '/mgmt/i18n';

export const getLocales = (): AxiosPromise<IGetLocales> => {
  return axios.get(uri);
}

export const getLocale = (id: string): AxiosPromise<IGetLocale> => {
  return axios.get(`${uri}/${id}`);
}

export const createLocale = (data: ILocaleReq): AxiosPromise => {
  return axios.post(uri, data);
};

export const updateLocale = (id: string, data: ILocaleReq): AxiosPromise => {
  return axios.put(`${uri}/${id}`, data);
};
